import React, { useEffect, useState } from 'react'
import { Text, View, TouchableOpacity } from 'react-native'
import DateTimePickerModal from 'react-native-modal-datetime-picker'
import { FormFieldsModel, ModelAnswerFromProps } from '../models/StoreDetailModel'
import styles from './InputDateFieldStyles'
import { updateFormAnswerSchedule } from '../../../../db-sqlite/repositories/schedule.repository'
import theme from '../../../../theme'
import { Feather } from '@expo/vector-icons'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import { ValidationParentContext } from './useValidationAlerts'
import {
    dateToDisplayString,
    dateToISODateString,
    isoDateStringToDate,
} from '../../../utils/formatDate.function'

interface InputDateFieldProps {
    item: FormFieldsModel
    form_id: string
    schedule_id: string
    store_id: string
    answerProp: ModelAnswerFromProps
    closeBottomSheet: (l: boolean) => void
    checkComplete: (option?: ModelAnswerFromProps) => void
    onSubInputMeasure?: (id: string, screenY: number, inputH: number) => void
    disabled?: boolean
    initialValue?: string
    parentContext?: ValidationParentContext
}

export const InputDateField = ({
    item,
    form_id,
    schedule_id,
    store_id,
    answerProp,
    checkComplete,
    onSubInputMeasure,
    disabled,
    initialValue,
}: InputDateFieldProps) => {
    const { languageFile } = getLanguage()

    const [date, setDate] = useState<Date | null>(null)
    const [isPickerVisible, setPickerVisible] = useState(false)
    const rowRef = React.useRef<View>(null)

    useEffect(() => {
        if (initialValue && initialValue !== '') {
            setDate(isoDateStringToDate(initialValue))
        }
    }, [item._id, initialValue])

    const create_answer = (selectedDate: Date) => {
        const inputText = dateToISODateString(selectedDate)
        const answer: ModelAnswerFromProps = {
            _id: item._id,
            option_selected_text: answerProp.option_selected_text,
            option_selected_id: answerProp.option_selected_id,
            question_id: answerProp.question_id,
            media: '',
            question_text: answerProp.question_text,
            score: item?.score ? item?.score.toString() : '0',
            status: 1,
            date_finish: new Date().toString(),
            date_init: new Date().toString(),
            question_input: '',
            field_media: '',
            field_text: inputText,
            questionScore: item?.questionScore ?? 0,
            index: answerProp.index,
            type: answerProp.type,
            ponderar: answerProp.questionScore && answerProp.questionScore > 0,

            question: item?.label || item?.title || '',
            questionOptionSelected: answerProp?.option_selected_id,
            questionOptionSelectedText: answerProp?.option_selected_text,
            questionType: (item as any).type,
            questionPrice: '',
            tag: '',
            questionImage: '',
            questionInput: inputText,

            sku: answerProp.sku,
            description: answerProp.description ?? '',
            description_short: answerProp.description_short ?? '',
        }

        updateFormAnswerSchedule({
            newAnswer: answer,
            schedule_id,
            form_id,
            store_id,
        })
        checkComplete(answer)
    }

    const handleConfirm = (selectedDate: Date) => {
        if (disabled) return
        setPickerVisible(false)
        setDate(selectedDate)
        create_answer(selectedDate)
    }

    const openPicker = () => {
        if (disabled) return
        if (onSubInputMeasure) {
            rowRef.current?.measureInWindow((x, y, w, h) => {
                onSubInputMeasure(item._id, y, h)
            })
        }
        setPickerVisible(true)
    }

    return (
        <View>
            {item.label && <Text style={styles.title}>{item.label}</Text>}

            <View ref={rowRef}>
                <TouchableOpacity
                    style={[styles.inputRow, disabled && styles.inputRowDisabled]}
                    activeOpacity={0.7}
                    onPress={openPicker}
                >
                    <Text
                        style={[styles.inputText, !date && styles.placeholderText]}
                    >
                        {date ? dateToDisplayString(date) : 'dd/mm/aaaa'}
                    </Text>
                    <Feather
                        name='calendar'
                        size={20}
                        color={theme.colors.colorPrimary}
                    />
                </TouchableOpacity>
            </View>

            {isPickerVisible && (
                <DateTimePickerModal
                    isVisible={isPickerVisible}
                    mode='date'
                    display='spinner'
                    date={date ?? new Date()}
                    onConfirm={handleConfirm}
                    onCancel={() => setPickerVisible(false)}
                    confirmTextIOS={languageFile.confirm}
                    cancelTextIOS={languageFile.cancel}
                    buttonTextColorIOS={theme.colors.colorPrimary}
                    themeVariant='light'
                    textColor='#000000'
                    isDarkModeEnabled={false}
                />
            )}
        </View>
    )
}
